module.exports = __webpack_public_path__ + "img/world_of_acredo@2x.5beb256.webp";